/**
 * Utility function to dispatch custom events to the window object
 * This function can be reused across multiple files
 *
 * @param {string} eventName - The name of the custom event
 * @param {*} data - The data to pass with the event
 */
function dispatchCustomEvent(eventName, data) {
  const event = new CustomEvent(eventName, {
    detail: data,
  });
  window.dispatchEvent(event);
}

window.dispatchCustomEvent = dispatchCustomEvent;
